/**
 * Copyright (c) 2019 Mozilla Inc. All Rights Reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
export const PRIVATE = Symbol("@@webxr-polyfill/XRHitTestResult");
import { PRIVATE as XRSESSION_PRIVATE } from "webxr-polyfill/src/api/XRSession";
import XRSpace from "webxr-polyfill/src/api/XRSpace";
import XRRigidTransform from "webxr-polyfill/src/api/XRRigidTransform";
import * as mat4 from "gl-matrix/src/gl-matrix/mat4";
import { ensureActiveFrame, trackAnchor } from "./anchorTracking.js";

export default class XRHitTestResult {
  constructor(frame, hit) {
    let transform = new XRRigidTransform(new Float32Array(hit.world_transform));

    this[PRIVATE] = {
      frame,
      transform,
      hit,
    };
  }

  getPose(baseSpace) {
    const space = new XRSpace();
    space._baseMatrix = mat4.copy(
      mat4.create(),
      this[PRIVATE].transform.matrix
    );
    return this[PRIVATE].frame.getPose(space, baseSpace);
  }

  get _frame() {
    return this[PRIVATE].frame;
  }

  get _hit() {
    return this[PRIVATE].hit;
  }

  createAnchor() {
    const frame = this[PRIVATE].frame;

    try {
      ensureActiveFrame(frame);
    } catch (error) {
      return Promise.reject(error);
    }

    const session = frame.session;
    const arKitWrapper = session[XRSESSION_PRIVATE].device._arKitWrapper;

    return arKitWrapper
      .createAnchorFromHit(this)
      .then((anchor) => trackAnchor(anchor, session));
  }
}
